module.exports = __webpack_public_path__ + "fonts/OpenSans-Bold.dbb97fd.ttf";